module.exports = __webpack_public_path__ + "img/hospital6.ff37515b.png";